import svg from './row-svg/usage.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function UsageIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default UsageIcon;
